import { useState } from "react"
import { useLoaderData, useLocation, useNavigate, useParams } from "react-router-dom"
import { motion } from "framer-motion"

import AppLayout from "layouts/app-layout"
import Transition from "components/transition"
import axios from "axios"
import { useLayoutEffect } from "react"
import Form from "pages/merchant/form"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import { useSWRConfig } from "swr"

const Edit = () => {
    const { cache } = useSWRConfig()

    const location = useLocation()
    const navigate = useNavigate()

    const id = useParams().id

    const [prevRouteState, setPrevRouteState] = useState({})

    const data = useLoaderData()

    const [errors, setErrors] = useState({})

    useLayoutEffect(() => {
        const getPrevRouteState = async () => {
            setPrevRouteState({
                back: location.state?.back,
                from: location.state?.from,
                transition: location.state?.transition
            })
        }

        getPrevRouteState()
    }, [])

    const handleSubmit = (data) => {
        nProgress.start()

        axios.patch(`${process.env.REACT_APP_BACKEND_URL}/merchant/update`, {
            branch_id: data.branch_id,
            merchant_id: data.merchant_id,
            name: data.name,
            bank: data.bank,
            terminals: data.terminals
        }).then((response) => {
            cache.clear()
            navigate({ pathname: '/merchant' })
            toast.success(response.data.message)
        }).catch((error) => {
            if (error.response.status === 422) {
                setErrors(error.response.data.errors)
            }
            nProgress.done()
            toast.error(error.response.data.message)
            console.log(error.response)
        })
    }

    return (
        <AppLayout title={`Edit ${id}`}>
            <div className="p-4 lg:p-8 space-y-16">
                <div>
                    {prevRouteState?.back && (
                        <button className="transition hover:opacity-50" onClick={() => navigate(-1)}>
                            <motion.h3 layout transition={{ type: "spring", damping: 20 }} layoutId={prevRouteState?.back} className="text-sm">{prevRouteState?.back}</motion.h3>
                        </button>
                    )}
                    <Transition type="slide" reversed>
                        <h1 className="text-3xl font-medium">
                            {`Edit ${id}`}
                        </h1>
                    </Transition>
                </div>
                <Transition type="slide" reversed>
                    <Form data={data} errors={errors} onSubmit={handleSubmit} />
                </Transition>
            </div>
        </AppLayout>
    )
}

export default Edit